/**
 * Guide step 4: duration.
 */
import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useAsterController } from "context";
import { VText, VImage } from "form";

/**
 * Shows estimated course duration.
 */
const Guide4 = () => {
  const { t } = useTranslation("common");

  const { courseId } = useParams();

  const [controller] = useAsterController();
  const { courses } = controller;

  const durationHr = useMemo(() => {
    const currCourse = (courses.data || []).find((v) => v.id === courseId) || {};
    return currCourse.duration / 60;
  }, [courseId, courses.data]);

  return (
    <Box className="flex flex-col md:flex-row justify-center items-center w-full max-w-screen-xl mx-auto gap-10 md:py-10">
      <Box className="flex justify-center items-center md:w-6/12 w-full">
        <VImage src={`${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/app/guide/guide4.svg`} className="w-full max-w-sm" draggable={false} />
      </Box>
      <Box className="flex flex-col gap-5 md:w-6/12 w-full">
        <VText className="text-4xl">
          {t("Every Monday")}, <br />
          {t("A new week begins!")}
        </VText>
        <VText className="text-2xl">{t("Every Monday morning, you will receive an email to advance in your training, week after week.")}</VText>
        <VText className="text-2xl">{t("We suggest a rhythm of one module per week but you cannot organize your time as you wish!")}</VText>
        <VText className="text-2xl">{t("Once the training has started, you can access the content whenever you want.")}</VText>
        <VText className="text-2xl">
          {t("The hard training")}{" "}
          <VText className="text-orange-600">
            {durationHr || 10} {t("hours")}
          </VText>
          , {t("plan about")} 2 {t("to")} 3 {t("hours per week in order to move forward in all serenity.")}
        </VText>
        <Box className="rounded-xl border border-solid border-gray-400 p-2">
          <VText className="text-2xl">{t("Tip: large working range or split sessions, it's up to you! In any case, remember to fix slots in advance in your agenda.")}</VText>
        </Box>
      </Box>
    </Box>
  );
};

export default Guide4;
